export const DISHOP_HUBRISE_ID = '176595652342.clients.hubrise.com';
export const HUBRISE_DOMAIN = 'https://manager.hubrise.com/';
